export default __webpack_public_path__ + "07308bbd97505939162aa5982bff9c17.png";